
import React, { useState, useEffect } from "react";
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UtilsLocalizedString from "../services/utilsLocalizedString";
import UtilsLocalizedSorting from "../services/utilsLocalizedSorting";
import axios from 'axios';
import * as XLSX from 'xlsx';

function CountriesPage(props) {

  const[dataLoaded, setLoad] = useState(false);
  const { t } = useTranslation();
  const [territoriesFromServer, setTerritoriesFromServer] = useState("");
  const [excelLoadedSheet, setExcelLoadedSheet] = useState(false);
  const [excelDataSheet, setExcelDataSheet]= useState("");

  useEffect(() => {
     const handleFetchFromUrl = async () => {
    if(!excelLoadedSheet) {
    try {
      const url = "https://storage.googleapis.com/fgr-data-visualisation-assets/fgr_silvagris_assets.xlsx";
      const response = await axios.get(url, { responseType: 'arraybuffer' });

      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[2];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setExcelDataSheet(jsonData);
      setExcelLoadedSheet(true);
      console.log(jsonData);
        fetchData(jsonData);
    } catch (error) {
    
      console.error('Error fetching or parsing Excel file:', error);
    }
  }
  };
    const fetchData = async (excelData) => {
      
      if(dataLoaded === false) {
        
        fetch(`${process.env.REACT_APP_BACKEND_API}/accounts/territories/`, {
          method: "GET",
           headers: {
           "accept": "application/json",
              "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
           },
 })
   .then((response) => response.json())
   .then((data) => {
   
    setTerritoriesFromServer(UtilsLocalizedSorting(props.lang, data.filter(terr => (excelData.filter((obj) => obj[3] === terr.id).length > 0) || (terr.focal_point_name !== null && 
      terr.focal_point_name !== ""))));
     console.log(data);
    setLoad(true);

   })
   .catch((error) => console.log(error));
      }
    };
    
 
  handleFetchFromUrl();



  }, [props.lang, dataLoaded]);

     return (
      <div className="App" style={{marginTop: "2rem"}}>
      <h5 className="title-body">{t('menu_item_countries')}</h5>
      <br></br>
       
      
      <div className="profiles-country-box">{
        Array.isArray(territoriesFromServer) && 
        territoriesFromServer !== undefined && 
        territoriesFromServer !== null &&
        territoriesFromServer !== "" 
        // &&
        // Array.isArray(countryList) && 
        // countryList !== undefined && 
        // countryList !== null &&
        // countryList !== "" 
        
        ? 
        <div style={{textAlign: props.lang !== "ar" ? "left" : "right"}} key="country-mapping">{
       territoriesFromServer.map((item, index) => 
      
      <div className="country-link" key={"country-mapping" + index}>

            <Link key={"countryname" + item.iso3} to={`/silvagris/${props.lang}/countries/${item.iso3}-${item.id}`} 
              // state={{country: item, territory: territoriesFromServer.filter(terr => terr.iso3 === item.iso3)}} 
              className="country-name">{UtilsLocalizedString(props.lang, item)}</Link><br></br></div>)}
         
            </div>
          : <div></div>}
                             

              


      </div></div>
     )
  }

  export default CountriesPage;